<!-- search bar -->
<div class="content-wrap">
    <div class="container">
        <div class="breadcrumb">
            <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
        </div>
        <div class="title-catalogue d-flex justify-content-between align-items-center">
            <h2>{{ 'IRONSIDE.partner-list.partners' | translate }}</h2>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="search-fournisseurs d-flex">
                <div class="wrap-input d-flex">
                    <label class="mb-0" for="">{{
                        'IRONSIDE.partner-list.company-name' | translate
                    }}</label>
                    <input
                        type="text"
                        placeholder="{{ 'IRONSIDE.partner-list.search-partner' | translate }}"
                        [(ngModel)]="partnerName"
                        (focusout)="emptyList()"
                        (input)="onSearchInput()"
                        (keyup)="onKeyUp($event)"
                    />
                </div>
                <button (click)="getListPartners()"><i class="pi pi-search"></i></button>
                <div class="autocomplete-list" *ngIf="autocompleteSearchlistParner.length > 0">
                    <ul class="p-0" style="list-style: none">
                        <li
                            class="ac-li"
                            *ngFor="let item of autocompleteSearchlistParner"
                            (click)="selectItem(item)"
                        >
                            {{ item.title }}
                        </li>
                    </ul>
                </div>
            </div>
            <div
                class="export"
                *ngIf="permissionService.isPermissionFonction('export-donnees-partenaires')"
            >
                <button
                    class="btn-common"
                    [disabled]="loadingExport"
                    (click)="onExporterPartenalres()"
                >
                    <span class="btn-export"
                        >{{ 'IRONSIDE.partner-list.export' | translate }}
                        <mat-spinner *ngIf="loadingExport" [diameter]="15"></mat-spinner
                    ></span>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="list-fournisseur">
    <ng-container *ngIf="loading">
        <div class="secsion-loading">
            <mat-spinner [diameter]="50"></mat-spinner>
        </div>
    </ng-container>
    <div class="container">
        <div class="col-12 p-0 pl-3">
            <form class="">
                <div class="wrap-pagination">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <div class="wrap-rows">
                            {{ 'IRONSIDE.partner-list.show' | translate }}
                            <p-dropdown
                                [(ngModel)]="pageSize"
                                (ngModelChange)="getListPartners()"
                                class="item-page"
                                [options]="listRows"
                                optionLabel=""
                            ></p-dropdown
                            >{{ 'IRONSIDE.partner-list.elements' | translate }}
                        </div>
                        <p-paginator
                            *ngIf="listPartners"
                            (onPageChange)="onPageChange3($event)"
                            [first]="first"
                            [rows]="pageSize"
                            [totalRecords]="totalRecords"
                            [showFirstLastIcon]="false"
                            [showCurrentPageReport]="false"
                        ></p-paginator>
                    </div>
                </div>
            </form>
            <div class="product-content d-flex align-items-center flex-wrap">
                <div
                    #lazyItem
                    [attr.data-lazyId]="partner?.id"
                    *ngFor="let partner of listPartners"
                    class="fournisseur-item d-flex align-items-center"
                >
                    <div class="d-flex w-full" style="gap: 6px">
                        <div class="logo-fournisseur w-50 p-10">
                            <img
                                [src]="
                                    partner?.logo
                                        ? partner?.logo
                                        : 'src-ironside/assets/images/image-default.jpg'
                                "
                                alt=""
                            />
                            <!-- skeleton start -->
                            <!-- <p-skeleton *ngIf="!partner?.logo" height="8rem"></p-skeleton> -->
                            <!-- skeleton end -->
                        </div>
                        <div class="fournisseur-body w-50">
                            <h3 class="mb-1">{{ partner?.title }}</h3>
                            <!-- <span class="truncate"
                        ><strong>{{ 'IRONSIDE.partner-list.phone' | translate }} : </strong
                            >{{ partner?.phone ? partner?.phone : '(aucune donnée)' }}</span
                            >
                            <span class="truncate"
                            ><strong>{{ 'IRONSIDE.partner-list.fax' | translate }} : </strong
                                >{{ partner?.fax ? partner?.fax : '(aucune donnée)' }}</span
                                >
                                <span class="truncate"
                                ><strong>{{ 'IRONSIDE.partner-list.email' | translate }} : </strong
                                    >{{ partner?.email ? partner?.email : '(aucune donnée)' }}</span
                                    >
                                    <span class="truncate"
                                    ><strong>{{ 'IRONSIDE.partner-list.city' | translate }} : </strong
                                        >{{ partner?.city ? partner?.city : '(aucune donnée)' }}</span
                                        > -->
                        </div>
                    </div>
                    <button (click)="goDetail(partner)" class="btn-common">
                        {{ 'IRONSIDE.partner-list.view-details' | translate }}
                    </button>
                </div>
            </div>
            <form class="">
                <div class="wrap-pagination">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <div class="wrap-rows">
                            {{ 'IRONSIDE.partner-list.show' | translate }}
                            <p-dropdown
                                [(ngModel)]="pageSize"
                                (ngModelChange)="getListPartners()"
                                class="item-page"
                                [options]="listRows"
                                optionLabel=""
                            ></p-dropdown
                            >{{ 'IRONSIDE.partner-list.elements' | translate }}
                        </div>
                        <p-paginator
                            *ngIf="listPartners"
                            (onPageChange)="onPageChange3($event)"
                            [first]="first"
                            [rows]="pageSize"
                            [totalRecords]="totalRecords"
                            [showFirstLastIcon]="false"
                            [showCurrentPageReport]="false"
                        ></p-paginator>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
